import { useId } from "react";
import type { ReactNode } from "react";

/** `<select>` com o rótulo do portal. Local à base de conhecimento: as telas dela têm cinco. */
export function Seletor({
  rotulo,
  valor,
  aoMudar,
  children,
  desabilitado = false,
  ajuda,
}: {
  rotulo: string;
  valor: string;
  aoMudar: (valor: string) => void;
  children: ReactNode;
  desabilitado?: boolean;
  ajuda?: string;
}) {
  const id = useId();
  return (
    <div className="campo">
      <label className="campo__rotulo" htmlFor={id}>
        {rotulo}
      </label>
      <select
        id={id}
        className="campo__controle"
        value={valor}
        disabled={desabilitado}
        onChange={(evento) => aoMudar(evento.target.value)}
      >
        {children}
      </select>
      {ajuda ? <p className="campo__ajuda">{ajuda}</p> : null}
    </div>
  );
}
